import z from "zod";

import trackEvent from "@lib/trackers";
import { createCall, spellbook } from "@sdk/spellbook";

import { withAccountAuthHeaders } from "./apiHelpers";

const endpoint = spellbook("/attendances").GET();

export const AttendancesQuerySchema = endpoint.q.omit({ total: true }).partial();
export type GetAttendancesQuery = z.infer<typeof AttendancesQuerySchema>;

export async function getAttendances(query: GetAttendancesQuery, signal?: AbortSignal) {
    const call = createCall({ ...endpoint, q: AttendancesQuerySchema }, (r) =>
        fetch(withAccountAuthHeaders(r)),
    );
    trackEvent({
        name: "timesheet - filters",
        params: { filters: query },
    });
    return await call({ query, signal });
}
